import { useEffect } from 'react'
import { useNavigate } from 'react-router'

import { useTheme } from '../../lib/hooks'
import useCheckout from '../Checkout/hooks/useCheckout'

const withScanner = Component => {
  const WithScannerComponent = ({ children }) => {
    const { addToCart } = useCheckout()
    const navigate = useNavigate()
    const theme = useTheme()

    useEffect(() => {
      if (window.BtApp) {
        window.BtApp.handleQrReader = payload => {
          console.log('[SCANNER] Bar Code Scanned', payload)
          const product = theme.products.find(o => o.id.toString() === payload.toString())
          if (!product) return false
          addToCart(product)
          navigate('/checkout')
          return product
        }
      }
      return () => {
        if (window.BtApp) {
          window.BtApp.handleQrReader = () => {}
        }
      }
    }, [])
    return <Component>{children}</Component>
  }
  return WithScannerComponent
}
export default withScanner

//for windows window.testScan("12341")
// const withScanner = Component => {
//   const WithScannerComponent = ({ children }) => {
//     const { addToCart } = useCheckout()
//     const navigate = useNavigate()
//     const theme = useTheme()

//     useEffect(() => {
//       window.testScan = productId => {
//         console.log('[SCANNER] Testing scan for product:', productId)
//         const product = theme.products.find(o => o.id.toString() === productId.toString())

//         if (!product) {
//           console.log('[SCANNER] Product not found')
//           return false
//         }

//         console.log('[SCANNER] Product found:', product)
//         addToCart(product)
//         navigate('/checkout')
//         return product
//       }

//       window.availableProducts = theme.products

//       if (window.BtApp) {
//         window.BtApp.handleQrReader = payload => {
//           return window.testScan(payload)
//         }
//       }

//       return () => {
//         if (window.BtApp) {
//           window.BtApp.handleQrReader = () => {}
//         }
//         window.testScan = undefined
//         window.availableProducts = undefined
//       }
//     }, [theme])

//     return <Component>{children}</Component>
//   }

//   return WithScannerComponent
// }
// export default withScanner
